import type { useDeveloperHasPermission } from "@services/useDeveloperHasPermission";
import type { useFeatureOn } from "@services/useFeatureOn";

export const getViewPermission = (
  featureOn: ReturnType<typeof useFeatureOn>,
  hasPermission: ReturnType<typeof useDeveloperHasPermission>
) => {
  return featureOn("feature_flags") && hasPermission("appGroup", { permission: "viewFeatureFlags" });
};
